import { createContext, useContext, useEffect, useState } from "react";

const WishlistContext = createContext(null);
const STORAGE = "lira_wishlist";

export const WishlistProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE)) || [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE, JSON.stringify(items));
  }, [items]);

  const has = (slug) => items.some((i) => i.slug === slug);

  const toggle = (product) => {
    setItems((prev) =>
      prev.some((i) => i.slug === product.slug)
        ? prev.filter((i) => i.slug !== product.slug)
        : [
            ...prev,
            {
              slug: product.slug,
              name: product.name,
              price: product.price,
              image: product.images[0],
              category_label: product.category_label,
            },
          ]
    );
  };

  const remove = (slug) => setItems((prev) => prev.filter((i) => i.slug !== slug));

  return (
    <WishlistContext.Provider value={{ items, has, toggle, remove, count: items.length }}>
      {children}
    </WishlistContext.Provider>
  );
};

export const useWishlist = () => useContext(WishlistContext);
